import { ButtonContained } from "@fizen/ui-components";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";
import { isString, upperCase } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { getApiManageNetwork } from "./apis/network";
import {
  postApiAutoaddprojectPublic,
  postCheckGameCode,
  postCheckLiquidity,
} from "./apis/referralcode";
import "./App.css";
import FizenInput from "./components/FizenInput";
import MImage from "./components/MImage";
import { copyToClipboard } from "./utils/copy";
import {
  checkIsAddress,
  getCollectionInfo,
  getTokenInfo,
} from "./utils/ethers";
// import * as yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
import { notifyError, notifySuccess } from "./utils/notifications";
import { capitalizeFirstLetter, middleTruncate } from "./utils/string";

const ViewReferralCodeComponent = ({
  listName,
  valueReferralCode = "BTĐDLgruopso1VN",
}) => {
  const { t } = useTranslation();
  const onclickCopy = () => {
    copyToClipboard(valueReferralCode);
    notifySuccess(t("notifySuccessCopy"));
  };

  // const handleShare = () => {
  //   window.flutter_inappwebview.callHandler(
  //     "fizenwallet-referer",
  //     valueReferralCode
  //   );
  // };

  return (
    <div>
      <Box
        className="h-40 rounded relative"
        sx={{
          background: "linear-gradient(257.45deg, #A475FF 1.51%, #592CFF 100%)",
        }}
      >
        <Box sx={{ top: "-2rem" }} className="absolute right-0">
          <MImage src="/assets/images/referral-code.svg" />
        </Box>
        <Box className="ml-4 pt-6 w-9/12">
          <div className="text-white font-bold">{t("titleCode")}</div>
          <div className="text-white text-xs opacity-70">
            {t("textYourReferralCode")}
          </div>
        </Box>
        <Box className="bottom-4 left-4 absolute flex justify-between">
          <div className="flex ">
            <div className="text-white font-bold mr-2">{valueReferralCode}</div>
            <div
              onClick={onclickCopy}
              className="flex flex-col justify-center opacity-70 cursor-pointer"
            >
              <ContentCopyIcon sx={{ fontSize: "16px", color: "#fff" }} />
            </div>
          </div>
        </Box>
        {/* <Box
          sx={{ background: "#FF8C24" }}
          className="absolute bottom-4 right-4 text-xs py-1 px-3 text-white rounded-full font-semibold cursor-pointer"
          onClick={handleShare}
        >
          {t("btnShare")}
        </Box> */}
      </Box>
      <Box sx={{ color: "#8089A9" }} className="my-4 text-sm font-semibold">
        {t("textContentYourReferralCode")}:
      </Box>
      {listName.map((item, index) => (
        <Box
          key={index}
          className="mb-4 pb-4"
          sx={{ borderBottom: "1px solid #E7E8EA" }}
        >
          <div className="text-sm font-semibold">
            {t("text")} {item.network}
          </div>
          <ul className="mx-4">
            {item.token.map((item, index) => (
              <li key={index} className="text-sm">
                {t("textFieldTokenName")}:{" "}
                <span className="font-semibold">{item.tokenName}</span>
              </li>
            ))}

            {item.collection.map((item, index) => (
              <li key={index} className="text-sm">
                {t("textFieldCollectionName")}:{" "}
                <span className="font-semibold">{item.collectionName}</span>
              </li>
            ))}
          </ul>
        </Box>
      ))}
    </div>
  );
};

const ReViewComponent = ({ listName, handleEdit, onCreate }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-8 z-10 min-h-screen">
      {listName.map((item, index) => (
        <div key={index} className="mb-8 px-4">
          <div className="text-lg font-semibold mb-2">{item.network}</div>
          {item.token.map((item, index) => (
            <div key={index} className="mb-4">
              <div className="mb-1 font-medium text-sm">
                {t("textToken")} #{index + 1}
              </div>
              <div className="text-sm">
                {t("textFieldTokenName")}: {item.tokenName}
              </div>
              <div className="text-sm">
                {t("textFieldTokenSymbol")}: {item.tokenSymbol}
              </div>
              <div className="text-sm">
                {t("textFieldTokenDecimal")}: {item.tokenDecimal}
              </div>
            </div>
          ))}
          {item.collection.map((item, index) => (
            <div key={index} className="mb-4">
              <div className="mb-1 font-medium text-sm">
                {t("textCollection")} #{index + 1}
              </div>
              <div className="text-sm">
                {t("textFieldCollectionContract")}:{" "}
                <Tooltip
                  className="cursor-pointer"
                  title={item.collectionContract}
                  arrow
                >
                  <span>{middleTruncate(item.collectionContract)}</span>
                </Tooltip>
              </div>
              <div className="text-sm">
                {t("textFieldCollectionSymbol")}: {item.collectionSymbol}
              </div>
            </div>
          ))}
        </div>
      ))}
      {/* <Box
        sx={{ boxShadow: "0px 0px 0px rgba(102, 101, 101, 0.25)", background: "#ffffff" }}
        className="w-full bottom-0 px-4"
      >
        <Box className="flex py-2">
          <div className="w-3/12">
            <Box
              onClick={handleEdit}
              className="rounded-full flex flex-col justify-center h-full"
              sx={{ background: "#F0EAF5", width: "40px", paddingLeft: "7px" }}
            >
              <ArrowBackOutlinedIcon />
            </Box>
          </div>
          <div className="w-9/12">
            <ButtonContained className="mr-10 w-full" onClick={onCreate}>
              Create
            </ButtonContained>
          </div>
        </Box>
      </Box> */}
    </div>
  );
};

const FieldInputForm = ({
  keyForm,
  control,
  errors,
  initialValue,
  value,
  idx,
}) => {
  return (
    <Controller
      key={keyForm}
      name={keyForm}
      control={control}
      defaultValue={initialValue}
      // rules={value.rules}
      render={
        ({ field }) => (
          <FizenInput
            {...field}
            error={!!errors[keyForm]}
            helperText={errors[keyForm]?.message}
            label={value.label}
            sx={value.sx}
            autoFocus={idx === 0}
            disabled={value.disabled ?? false}
          />
        )
        // )
      }
    />
  );
};

const initialValue = {
  networkId_1: "",
  contract_11: "",
  decimal_11: "",
  tokenSymbol_11: "",
  collectionContract_11: "",
  collectionSymbol_11: "",
};

const DEFAULT_LIST_NETWORK = [{ network: 1, token: [1], collection: [1] }];

export function useFetchDataNetwork() {
  const { data, isLoading, isFetching, refetch } = useQuery(
    // key for query
    ["ManageNetwork"],
    () =>
      // Change API here
      getApiManageNetwork(),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 12000,
      retry: 0,
    }
  );

  return { data, isLoading, isFetching, refetch };
}

// Hook to crreate/edit data
function useCreateData() {
  return useMutation((data) => {
    // API Create here
    return postApiAutoaddprojectPublic(data);
  });
}

function iOS() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

function App() {
  const { t } = useTranslation();
  const { data: listNetworks } = useFetchDataNetwork();
  const [listNetworkReferralCode, setListNetworkReferralCode] =
    useState(DEFAULT_LIST_NETWORK);
  const [review, setReview] = useState(false);
  const [viewReferralCode, setViewReferralCode] = useState(false);
  const [title, setTitle] = useState(t("titleCreate"));
  const [activeNetwork, setActiveNetwork] = useState({
    active: 1,
    list: listNetworkReferralCode,
  });
  const [listName, setListName] = useState([]);
  const [request, setRequest] = useState({});
  const [currentFieldChange, setCurrentFieldChange] = useState("networkId_1");
  const [loading, setLoading] = useState(false);
  const [nameCode, setNameCode] = useState("");
  const [errorNameCode, setErrorNameCode] = useState("");
  const oldWatch = useRef(null);

  const form = useForm({
    defaultValues: initialValue,
    resolver: undefined,
  });
  const {
    watch,
    control,
    handleSubmit,
    setValue,
    getValues,
    //reset,
    setError,
    clearErrors,
    formState: { errors },
  } = form;

  const checkSubmit = useMemo(() => {
    let objSchema = [];
    listNetworkReferralCode.forEach((itemContract) => {
      const listToken = itemContract.token.map(
        (itemToken) => `tokenSymbol_${itemContract.network}${itemToken}`
      );
      objSchema = [...objSchema, listToken];
    });
    const check = objSchema
      .flat()
      .map((item) => getValues(item))
      .every((item) => item);
    return check;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch(), listNetworkReferralCode]);

  const formModelToken = useMemo(() => {
    return {
      contract: {
        label: `${t("textFieldTokenContarct")} (*)`,
        name: "contract",
        sx: { width: "100%", marginTop: 1 },
        disabled: review,
      },
      tokenSymbol: {
        label: `${t("textFieldTokenSymbol")} (*)`,
        name: "tokenSymbol",
        sx: { width: "100%", marginTop: 1, pointerEvents: "none" },
        disabled: true,
      },
      decimal: {
        label: `${t("textFieldTokenDecimal")} (*)`,
        name: "decimal",
        sx: { width: "100%", marginTop: 1, pointerEvents: "none" },
        disabled: true,
      },
      tokenName: {
        label: `${t("textFieldTokenName")} (*)`,
        name: "tokenName",
        sx: {
          width: "100%",
          marginTop: 1,
          display: "none",
          pointerEvents: "none",
        },
        disabled: true,
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [review]);

  const formModelCollection = useMemo(() => {
    return {
      collectionContract: {
        label: `${t("textFieldCollectionContract")}`,
        name: "collectionContract",
        sx: { width: "100%", marginTop: 1 },
        disabled: review,
      },
      collectionSymbol: {
        label: `${t("textFieldCollectionSymbol")}`,
        name: "collectionSymbol",
        sx: { width: "100%", marginTop: 1, pointerEvents: "none" },
        disabled: true,
      },
      collectionName: {
        label: `${t("textFieldCollectionName")}`,
        name: "collectionName",
        sx: {
          width: "100%",
          marginTop: 1,
          display: "none",
          pointerEvents: "none",
        },
        disabled: true,
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [review]);

  const listSelectedNetwork = useMemo(() => {
    const list = listNetworkReferralCode.map((item) => {
      return item.network;
    });
    return list
      .map((item) => {
        return getValues(`networkId_${item}`);
      })
      .filter(Boolean);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch(), listNetworkReferralCode]);

  const mutationCreate = useCreateData();

  // get current field change - start
  useEffect(() => {
    if (
      !oldWatch.current ||
      Object.keys(oldWatch.current).length !== Object.keys(watch()).length
    ) {
      oldWatch.current = watch();
      return;
    }
    if (JSON.stringify(oldWatch.current) === JSON.stringify(watch())) {
      return;
    }
    const arrValueOldWatch = Object.values(oldWatch.current);
    const arrValueCurrentWatch = Object.values(watch());
    const indexFieldChange = arrValueOldWatch?.findIndex(
      (item, index) => item !== arrValueCurrentWatch[index]
    );
    setCurrentFieldChange(Object.keys(oldWatch.current)[indexFieldChange]);
    oldWatch.current = watch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch()]); // end

  useEffect(() => {
    if (currentFieldChange.includes("networkId")) {
      const indexNetwork = currentFieldChange.split("_")[1].charAt(0);
      const network = listNetworkReferralCode?.find(
        (item) => item.network === parseInt(indexNetwork)
      );
      clearErrors(`networkId_${indexNetwork}`);
      network.token.forEach((itemToken) => {
        setValue(`contract_${indexNetwork}${itemToken}`, "");
        setValue(`tokenSymbol_${indexNetwork}${itemToken}`, "");
        setValue(`decimal_${indexNetwork}${itemToken}`, "");
        setValue(`tokenName_${indexNetwork}${itemToken}`, "");
        clearErrors([`contract_${indexNetwork}${itemToken}`]);
      });
      network.token.forEach((itemToken) => {
        setValue(`collectionContract_${indexNetwork}${itemToken}`, "");
        setValue(`collectionSymbol_${indexNetwork}${itemToken}`, "");
        setValue(`collectionName_${indexNetwork}${itemToken}`, "");
        clearErrors(`collectionContract_${indexNetwork}${itemToken}`);
      });
    }
    if (
      currentFieldChange.includes("contract") ||
      currentFieldChange.includes("collectionContract")
    ) {
      const contractValue = getValues(currentFieldChange);
      const indexField = currentFieldChange.split("_")[1];
      const indexNetwork = currentFieldChange.split("_")[1].charAt(0);
      const networkValue = getValues(`networkId_${indexNetwork}`);
      if (contractValue) {
        if (!networkValue) {
          setError(`networkId_${indexNetwork}`, {
            type: "validate",
            message: t("textErrorSelectNetwork"),
          });
          return;
        } else {
          if (!checkIsAddress(contractValue)) {
            setError(currentFieldChange, {
              type: "validate",
              message: t("textErrorInvalidContract"),
            });
            if (currentFieldChange.includes("contract")) {
              setValue(`tokenSymbol_${indexField}`, "");
              setValue(`decimal_${indexField}`, "");
              setValue(`tokenName_${indexField}`, "");
            }
            if (currentFieldChange.includes("collectionContract")) {
              setValue(`collectionSymbol_${indexField}`, "");
              setValue(`collectionName_${indexField}`, "");
            }
            return;
          } else {
            if (currentFieldChange.includes("collectionContract")) {
              let check = false;
              Object.entries(watch()).forEach(([key, value]) => {
                if (
                  key.includes(`collectionContract_${indexNetwork}`) &&
                  contractValue === value &&
                  key !== currentFieldChange
                ) {
                  check = true;
                } else {
                  clearErrors(currentFieldChange);
                }
              });
              if (check) {
                setError(currentFieldChange, {
                  type: "validate",
                  message: "Contract already existed",
                });
                return;
              }
            }
            if (currentFieldChange.includes("contract")) {
              let check = false;
              Object.entries(watch()).forEach(([key, value]) => {
                if (
                  key.includes(`contract_${indexNetwork}`) &&
                  contractValue === value &&
                  key !== currentFieldChange
                ) {
                  check = true;
                } else {
                  clearErrors(currentFieldChange);
                }
              });
              if (check) {
                setError(currentFieldChange, {
                  type: "validate",
                  message: "Contract already existed",
                });
                return;
              }
              const chainID = listNetworks?.data?.data?.find(
                (item) => item.id === networkValue
              )?.chainID;
              const request = {
                chainID: parseInt(chainID),
                tokenContract: contractValue,
              };
              postCheckLiquidity(request).then((res) => {
                if (!res) {
                  setError(currentFieldChange, {
                    type: "validate",
                    message: t("textErrorLiquidity"),
                  });
                  return;
                }
              });
            }
            clearErrors(currentFieldChange);
          }

          const provider = listNetworks?.data?.data?.find(
            (item) => item.id === networkValue
          )?.websocket;
          if (currentFieldChange.includes("contract")) {
            getTokenInfo(contractValue, provider)
              .then((res) => {
                if (res) {
                  setValue(`tokenSymbol_${indexField}`, res[1]);
                  setValue(`decimal_${indexField}`, res[0].toString());
                  setValue(`tokenName_${indexField}`, res[2]);
                  clearErrors([
                    `tokenSymbol_${indexField}`,
                    `decimal_${indexField}`,
                    currentFieldChange,
                  ]);
                }
              })
              .catch((err) =>
                setError(currentFieldChange, {
                  type: "validate",
                  message: t("textErrorInvalidContract"),
                })
              );
          }
          if (currentFieldChange.includes("collectionContract")) {
            getCollectionInfo(contractValue, provider)
              .then((res) => {
                if (res) {
                  setValue(`collectionSymbol_${indexField}`, res[0]);
                  setValue(`collectionName_${indexField}`, res[1]);
                  clearErrors([
                    `collectionSymbol_${indexField}`,
                    currentFieldChange,
                  ]);
                }
              })
              .catch((err) =>
                setError(currentFieldChange, {
                  type: "validate",
                  message: t("textErrorInvalidContract"),
                })
              );
          }
        }
      } else {
        if (currentFieldChange.includes("collectionContract")) {
          clearErrors(currentFieldChange);
          setValue(`collectionSymbol_${indexField}`, "");
          setValue(`collectionName_${indexField}`, "");
        }
        if (currentFieldChange.includes("contract")) {
          clearErrors(currentFieldChange);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getValues(currentFieldChange), currentFieldChange]);

  const handleAddToken = (indexContract) => {
    const newList = [...listNetworkReferralCode];
    const index = newList.indexOf(indexContract);
    newList[index].token = [
      ...newList[index].token,
      newList[index].token[newList[index].token.length - 1] + 1,
    ];
    setListNetworkReferralCode(newList);
  };

  const deleteToken = (indexToken, itemContract) => {
    const listCopy = [...listNetworkReferralCode];
    const index = listCopy.indexOf(itemContract);
    const newListToken = listCopy[index].token.filter(
      (item) => item !== indexToken
    );
    listCopy[index].token = newListToken;
    setListNetworkReferralCode(listCopy);
    clearErrors(`contract_${itemContract.network}${indexToken}`);
    setValue(`contract_${itemContract.network}${indexToken}`, "");
  };

  const handleAddCollection = (itemContract) => {
    const newList = [...listNetworkReferralCode];
    const index = newList.indexOf(itemContract);
    newList[index].collection = [
      ...newList[index].collection,
      newList[index].collection[newList[index].collection.length - 1] + 1,
    ];
    setListNetworkReferralCode(newList);
  };

  const deleteCollection = (indexCollection, itemContract) => {
    const listCopy = [...listNetworkReferralCode];
    const index = listCopy.indexOf(itemContract);
    const newListCollection = listCopy[index].collection.filter(
      (item) => item !== indexCollection
    );
    listCopy[index].collection = newListCollection;
    setListNetworkReferralCode(listCopy);
    clearErrors(`collectionContract_${itemContract.network}${indexCollection}`);
    setValue(
      `collectionContract_${itemContract.network}${indexCollection}`,
      ""
    );
  };

  const handleAddContractDetail = () => {
    const newList = [
      ...listNetworkReferralCode,
      {
        network:
          listNetworkReferralCode[listNetworkReferralCode.length - 1].network +
          1,
        token: [1],
        collection: [1],
      },
    ];
    setActiveNetwork({
      active: newList[newList.length - 1].network,
      list: [newList[newList.length - 1]],
    });
    setListNetworkReferralCode(newList);
  };

  const deleteContractDetail = (index) => {
    const listCopy = [...listNetworkReferralCode];
    const newList = listCopy.filter((item) => item.network !== index);
    setListNetworkReferralCode(newList);
    if (activeNetwork.active === index) {
      setActiveNetwork({ active: newList[0].network, list: [newList[0]] });
    }
  };

  //   const handleReview = () => {
  //     setReview(true);
  //     setTitle("Review your referral code");
  //   };

  const handleEdit = () => {
    setListName([]);
    setReview(false);
    setTitle(t("titleCreate"));
  };

  const getNameNetwork = (id) => {
    const name = listNetworks?.data?.data?.find((item) => item.id === id)?.name;
    return name
      .split("-")
      .map((item) => capitalizeFirstLetter(item))
      .join(" ");
  };

  const styleNameNetwork = (name) => {
    if (name === "okc") return upperCase(name);
    return name
      .split("-")
      .map((item) => capitalizeFirstLetter(item))
      .join(" ");
  };

  const checkProjectCode = async (e) => {
    const value = e.target.value;
    setNameCode(value);
    if (value) {
      try {
        await postCheckGameCode({ gameCode: value });
        setErrorNameCode("");
      } catch (error) {
        //notifyError(error.response.data.description);
        setErrorNameCode("Project code already exist.");
      }
    } else {
      setErrorNameCode("Project code is required.");
    }
  };

  const onSubmit = async (data) => {
    let arrForm = [];
    listNetworkReferralCode.forEach((itemContract) => {
      const listToken = itemContract?.token?.map((itemToken) => ({
        networkId: data[`networkId_${itemContract.network}`],
        contract: data[`contract_${itemContract.network}${itemToken}`],
        symbol: data[`tokenSymbol_${itemContract.network}${itemToken}`],
        decimal: data[`decimal_${itemContract.network}${itemToken}`],
        name: data[`tokenName_${itemContract.network}${itemToken}`],
        contractType: "ERC20",
      }));
      const listNameToken = itemContract?.token?.map((itemToken) => ({
        tokenName: data[`tokenName_${itemContract.network}${itemToken}`],
        tokenSymbol: data[`tokenSymbol_${itemContract.network}${itemToken}`],
        tokenDecimal: data[`decimal_${itemContract.network}${itemToken}`],
      }));
      const listCollection = itemContract.collection
        .map((itemCollection) => ({
          networkId: data[`networkId_${itemContract.network}`],
          contract:
            data[`collectionContract_${itemContract.network}${itemCollection}`],
          symbol:
            data[`collectionSymbol_${itemContract.network}${itemCollection}`],
          name: data[`collectionName_${itemContract.network}${itemCollection}`],
          contractType: "ERC721",
        }))
        .filter((item) => item.contract);
      const listNameCollection = itemContract.collection
        .map((itemCollection) => ({
          collectionContract:
            data[`collectionContract_${itemContract.network}${itemCollection}`],
          collectionName:
            data[`collectionName_${itemContract.network}${itemCollection}`],
          collectionSymbol:
            data[`collectionSymbol_${itemContract.network}${itemCollection}`],
        }))
        .filter((item) => item.collectionName);
      arrForm = [...arrForm, listToken, listCollection];
      setListName((n) => [
        ...n,
        {
          network: getNameNetwork(data[`networkId_${itemContract.network}`]),
          token: listNameToken,
          collection: listNameCollection,
        },
      ]);
    });
    const dataForm = {
      tokens: arrForm.flat(),
      gameCode: nameCode.trim(),
    };

    setRequest(dataForm);
    setReview(true);
    setTitle(t("titleReview"));
    window.scrollTo(0, 0);
  };

  const onCreate = async () => {
    setLoading(true);
    try {
      await mutationCreate.mutateAsync(request).then((res) => {});
      notifySuccess(t("notifySuccessCreate"));
      setTitle("");
      setViewReferralCode(true);
      setLoading(false);
    } catch (error) {
      notifyError(error.response.data.description);
      setLoading(false);
    }
  };

  const handleActiveNetwork = (network) => {
    const listNetwork = listNetworkReferralCode?.find(
      (item) => item.network === network
    );
    const data = {
      active: network,
      list: [listNetwork],
    };
    setActiveNetwork(data);
  };

  return (
    <div
      className={`${viewReferralCode ? "px-4 py-10" : " pt-4 min-h-screen"}`}
    >
      <div
        className={`${
          viewReferralCode ? "text-center" : "text-4xl"
        } font-bold mx-4`}
      >
        {title}
      </div>
      {viewReferralCode ? (
        <div className="text-xl text-center my-2"></div>
      ) : (
        <>
          {!review ? (
            <ul
              className="text-sm my-2 mx-4 font-normal"
              style={{ color: "#8089A9", listStyle: "disc" }}
            >
              <li className="ml-5 mb-4">{t("textCreateReferralCode1")}</li>
              <li className="ml-5">{t("textCreateReferralCode2")}</li>
            </ul>
          ) : (
            <div className="text-xs my-2"></div>
          )}
        </>
      )}

      {!viewReferralCode ? (
        <>
          {/* {!review && ( */}
          <form onSubmit={handleSubmit(onSubmit)} className="min-h-screen">
            <Divider sx={{ mb: 3 }} />
            {!review ? (
              <Box className="rounded z-10 mx-4">
                <Box className="my-4">
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      label="Project code"
                      error={errorNameCode}
                      helperText={errorNameCode}
                      value={nameCode}
                      onChange={checkProjectCode}
                      //onBlur={checkProjectCode}
                    />
                  </FormControl>
                </Box>
                <div className="flex max-w-full">
                  <Box
                    sx={{
                      maxWidth: "90%",
                      scrollbarWidth: 0,
                      "::-webkit-scrollbar": {
                        width: 0,
                      },
                    }}
                    className="flex overflow-x-auto"
                  >
                    {listNetworkReferralCode.map(
                      (itemNetwork, indexNetwork) => (
                        <Box
                          key={itemNetwork.network}
                          className="flex flex-col justify-center cursor-pointer"
                          sx={{ webkitTapHighlightColor: "transparent" }}
                        >
                          <Box
                            className={`${
                              itemNetwork.network === activeNetwork.active
                                ? "text-white"
                                : ""
                            } flex mr-2 rounded-full`}
                            sx={{
                              border: "1px solid #E7E8EA",
                              background:
                                itemNetwork.network === activeNetwork.active
                                  ? "#282736"
                                  : "transparent",
                              height: "30px",
                              webkitTapHighlightColor: "transparent",
                            }}
                          >
                            <Box
                              onClick={() =>
                                handleActiveNetwork(itemNetwork.network)
                              }
                              className="flex flex-col justify-center ml-2 text-xs"
                              sx={{ minWidth: "4.5rem" }}
                            >
                              {t("textNetwork")} {indexNetwork + 1}
                            </Box>
                            {listNetworkReferralCode.length > 1 && (
                              <div
                                className="flex flex-col justify-center"
                                onClick={() =>
                                  deleteContractDetail(itemNetwork.network)
                                }
                              >
                                {/* <IconButton
                                  //aria-label="close"
                                  onClick={() =>
                                    deleteContractDetail(itemNetwork.network)
                                  }
                                  sx={{
                                    position: "unset",
                                    right: 5,
                                    top: 5,
                                    color: "red",
                                  }}
                                  disableFocusRipple={false}
                                  disableRipple={false}
                                > */}
                                <CloseIcon
                                  sx={{ color: "red", marginRight: "2px" }}
                                />
                                {/* </div></IconButton> */}
                              </div>
                            )}
                          </Box>
                        </Box>
                      )
                    )}
                  </Box>
                  <Box
                    sx={{ borderLeft: "1px solid #E6E6E6", height: "30px" }}
                    className="flex justify-end ml-2"
                  >
                    <AddCircleOutlinedIcon
                      className="cursor-pointer"
                      sx={{ fontSize: "30px", color: "#8089A9" }}
                      onClick={handleAddContractDetail}
                    />
                  </Box>
                </div>
                {activeNetwork?.list?.map((itemNetwork, indexNetwork) => (
                  <Box
                    className="my-4 p-4 rounded"
                    sx={{ border: "1px solid #bdbadb" }}
                    key={itemNetwork.network}
                  >
                    <Box className="flex">
                      <Controller
                        key={`networkId_${itemNetwork.network}`}
                        name={`networkId_${itemNetwork.network}`}
                        control={control}
                        defaultValue={
                          initialValue[`networkId_${itemNetwork.network}`]
                        }
                        // rules={value.rules}
                        render={({ field }) => {
                          const list = listNetworks?.data?.data.sort(
                            (a, b) => Number(b.isMainnet) - Number(a.isMainnet)
                          );
                          const options = list
                            ? list?.map((item) => ({
                                value: item.id,
                                label: styleNameNetwork(item.name),
                                icon: item.icon,
                              }))
                            : [];
                          const activeName = list?.find(
                            (item) => item.id === field.value
                          )?.name;
                          return (
                            <FormControl
                              error={
                                !!errors[`networkId_${itemNetwork.network}`]
                              }
                              sx={{ width: "100%" }}
                            >
                              <InputLabel>
                                {t("textFieldNetworkName")}
                              </InputLabel>
                              <Select
                                {...field}
                                label={t("textFieldNetworkName")}
                                renderValue={(selected) =>
                                  styleNameNetwork(activeName)
                                }
                              >
                                <MenuItem
                                  sx={{ fontSize: "18px", fontWeight: 500 }}
                                >
                                  {t("textSelectNetwork")}
                                </MenuItem>
                                {options.map((item, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={isString(item) ? item : item.value}
                                    disabled={listSelectedNetwork.includes(
                                      item.value
                                    )}
                                    sx={{
                                      fontSize: "16px",
                                      fontFamily: "Inter",
                                      fontWeight: 400,
                                    }}
                                  >
                                    <Radio
                                      checked={field.value === item.value}
                                    ></Radio>
                                    <div className="mx-2">
                                      <MImage
                                        sx={{ width: "24px", height: "24px" }}
                                        src={item.icon}
                                      />
                                    </div>
                                    {isString(item) ? item : item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors[`networkId_${itemNetwork.network}`]
                                ?.message && (
                                <FormHelperText>
                                  {
                                    errors[`networkId_${itemNetwork.network}`]
                                      ?.message
                                  }
                                </FormHelperText>
                              )}
                            </FormControl>
                          );
                        }}
                      />
                      <div className="flex"></div>
                    </Box>
                    <Box className="">
                      <Box
                        className=""
                        sx={{ borderBottom: "2px solid #F4F4F9" }}
                      >
                        <h3 className="mt-4 font-semibold">{t("textToken")}</h3>
                        {itemNetwork.token.map((itemToken, indexToken) => (
                          <Box
                            key={itemToken}
                            sx={{
                              borderBottom: "1px solid #F4F4F9",
                              marginBottom: "5px",
                            }}
                          >
                            <div className="flex">
                              <h5 className="my-4 text-sm font-medium">
                                {t("textToken")} #{indexToken + 1}
                              </h5>{" "}
                              <div className="flex">
                                {itemNetwork.token.length > 1 && (
                                  <div
                                    className="flex flex-col justify-center ml-2"
                                    onClick={() =>
                                      deleteToken(itemToken, itemNetwork)
                                    }
                                  >
                                    <CloseIcon
                                      sx={{
                                        color: "red",
                                        marginRight: "2px",
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                            {Object.entries(formModelToken).map(
                              ([key, value], idx) => (
                                <FieldInputForm
                                  keyForm={`${key}_${itemNetwork.network}${itemToken}`}
                                  //idx={idx}
                                  control={control}
                                  errors={errors}
                                  initialValue={
                                    initialValue[
                                      `${key}_${itemNetwork.network}${itemToken}`
                                    ]
                                  }
                                  value={value}
                                />
                              )
                            )}
                          </Box>
                        ))}
                        <div className="flex ml-2 cursor-pointer my-4">
                          <AddCircleOutlinedIcon
                            className="cursor-pointer"
                            sx={{ fontSize: "35px", color: "#8089A9" }}
                            onClick={() => handleAddToken(itemNetwork)}
                          />
                          <div className="flex flex-col justify-center ml-2 text-sm">
                            {t("textAddToken")}
                          </div>
                        </div>
                      </Box>
                      <Box className="">
                        <h3 className="mt-4 font-semibold">
                          {t("textCollection")}
                        </h3>
                        {itemNetwork.collection.map(
                          (itemCollection, indexCollection) => (
                            <Box key={itemCollection}>
                              <div className="flex">
                                <h5 className="my-4 text-sm font-medium">
                                  {t("textCollection")} #{indexCollection + 1}
                                </h5>{" "}
                                <div className="flex">
                                  {itemNetwork.collection.length > 1 && (
                                    <div
                                      className="flex flex-col justify-center ml-2"
                                      onClick={() =>
                                        deleteCollection(
                                          itemCollection,
                                          itemNetwork
                                        )
                                      }
                                    >
                                      <CloseIcon
                                        sx={{
                                          color: "red",
                                          marginRight: "2px",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                              {Object.entries(formModelCollection).map(
                                ([key, value], idx) => (
                                  <FieldInputForm
                                    keyForm={`${key}_${itemNetwork.network}${itemCollection}`}
                                    //idx={idx}
                                    control={control}
                                    errors={errors}
                                    initialValue={
                                      initialValue[
                                        `${key}_${itemNetwork.network}${itemCollection}`
                                      ]
                                    }
                                    value={value}
                                  />
                                )
                              )}
                            </Box>
                          )
                        )}
                        <div className="flex ml-2 my-4 cursor-pointer">
                          <AddCircleOutlinedIcon
                            className="cursor-pointer"
                            sx={{ fontSize: "35px", color: "#8089A9" }}
                            onClick={() => handleAddCollection(itemNetwork)}
                          />
                          <div className="flex flex-col justify-center ml-2 text-sm">
                            {t("textAddCollection")}
                          </div>
                        </div>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            ) : (
              <ReViewComponent
                listName={listName}
                handleEdit={handleEdit}
                onCreate={onCreate}
              />
            )}
            <Box
              sx={{
                boxShadow: "-2px 0px 20px rgba(102, 101, 101, 0.25)",
                background: "#ffffff",
                zIndex: 999,
              }}
              className={`${
                !review ? "flex justify-center px-8 sticky" : "sticky"
              } ${iOS() ? "pb-6" : "pb-5"} pt-3  bottom-0 w-full`}
            >
              {!review ? (
                <ButtonContained
                  type="submit"
                  disabled={
                    !checkSubmit ||
                    Object.keys(errors).length > 0 ||
                    errorNameCode ||
                    !nameCode
                  }
                  sx={{
                    background: "#500EC1",
                    borderRadius: "30px",
                    ":hover": {
                      background: "#500EC1",
                    },
                    textTransform: "capitalize",
                    height: "44px",
                  }}
                  className="mt-4 w-full mb-4"
                >
                  {t("btnNext")}
                </ButtonContained>
              ) : (
                <Box
                  sx={{
                    boxShadow: "0px 0px 0px rgba(102, 101, 101, 0.25)",
                    background: "#ffffff",
                  }}
                  className="w-full bottom-0"
                >
                  <Box className="flex justify-evenly">
                    <div className="">
                      <Box
                        onClick={handleEdit}
                        className="rounded-full flex flex-col justify-center h-full"
                        sx={{
                          background: "#F0EAF5",
                          width: "44px",
                          paddingLeft: "8px",
                        }}
                      >
                        <ArrowBackOutlinedIcon />
                      </Box>
                    </div>
                    <div className="w-8/12">
                      <ButtonContained
                        sx={{
                          background: "#500EC1",
                          borderRadius: "30px",
                          ":hover": {
                            background: "#500EC1",
                          },
                          ":disabled": {
                            color: "#ffffff",
                          },
                          textTransform: "capitalize",
                          height: "44px",
                        }}
                        className="mr-10 w-full mx-4"
                        onClick={onCreate}
                        loading={loading}
                      >
                        {t("btnCreateReferralCode")}
                      </ButtonContained>
                    </div>
                  </Box>
                </Box>
              )}
            </Box>
          </form>
        </>
      ) : (
        <ViewReferralCodeComponent
          listName={listName}
          valueReferralCode={nameCode}
        />
      )}
    </div>
  );
}

export default App;
